import { PointOfContactPeriod } from './contact.types';

export class AgencyDetails {
  uidIdentifier?: string;

  constructor(
    public uid: string,
    public name: string,
    public shortName: string,
    public pictureFullPath: string | null,
    public canDownloadClient: boolean,
    public canSelectiveUpload: boolean,
    public isLoginPinRequired: boolean,
    public canDeleteFiles: boolean,
    public storageInfo: StorageInfo,
    public phone: string | undefined,
    public emailAddress: string | undefined,
    public address: string | undefined,
    public caseDownloadAvailableDays: number,
    public primaryContact: Contact,
    public secondaryContact: Contact,
    public manualDeleteRetainDays: number | undefined,
    public canUseCad: boolean,
    public canUseSelfRedaction: boolean
  ) {}
}

export class StorageInfo {
  constructor(public accessKeyId: string, public regionName: string, public secretAccessKey: string) {}
}

export class Contact {
  constructor(
    public contactEmail: string | undefined,
    public contactName: string | undefined,
    public contactPhone: string | undefined,
    public contactNotificationPeriod: PointOfContactPeriod | undefined
  ) {}
}

export class AgencyDetailsResponse {
  uidIdentifier?: string;

  constructor(
    public UID: string,
    public Name: string,
    public PictureFullPath: string,
    public CanDownloadClient: boolean,
    public CanSelectiveUpload: boolean,
    public CanDeleteFiles: boolean,
    public IsLoginPinRequired: boolean,
    public AwsInfo: AwsInfoResponse,
    public CaseDownloadAvailableDays: number,
    public ShortName: string,
    public Phone: string | undefined,
    public EmailAddress: string | undefined,
    public Address: string | undefined,
    public ManualDeleteRetainDays: number | undefined,
    public PrimaryContactName: string | undefined,
    public PrimaryContactEmail: string | undefined,
    public PrimaryContactPhone: string | undefined,
    public PrimaryContactNotificationPeriod: PointOfContactPeriod | undefined,
    public SecondaryContactName: string | undefined,
    public SecondaryContactPhone: string | undefined,
    public SecondaryContactEmail: string | undefined,
    public SecondaryContactNotificationPeriod: PointOfContactPeriod | undefined,
    public CanUseCad: boolean,
    public CanUseSelfRedaction: boolean
  ) {}
}

export class AgencyDetailsCustomerResponse {
  constructor(public Customer: CustomerResponse) {}
}

export class AwsInfoResponse {
  constructor(public AccessKeyId: string, public RegionName: string, public SecretAccessKey: string) {}
}

export class CustomerResponse {
  constructor(
    public UID: string,
    public Name: string,
    public ShortName: string,
    public PictureFullPath: string,
    public CanDownloadClient: boolean,
    public CanSelectiveUpload: boolean,
    public CanDeleteFiles: boolean,
    public IsLoginPinRequired: boolean,
    public CaseDownloadAvailableDays: number,
    public AwsInfo: AwsInfoResponse,
    public CanUseCad: boolean,
    public CanUseSelfRedaction: boolean
  ) {}
}

export class AgencyDetailsUpdateObject {
  constructor(
    public Address: string | undefined | null,
    public CaseDownloadAvailableDays: number | undefined,
    public EmailAddress: string | undefined | null,
    public ManualDeleteRetainDays: number | undefined,
    public Name: string | undefined | null,
    public Phone: string | undefined | null,
    public PrimaryContactEmail: string | undefined | null,
    public PrimaryContactName: string | undefined | null,
    public PrimaryContactNotificationPeriod: PointOfContactPeriod | undefined | null,
    public SecondaryContactPhone: string | undefined | null,
    public SecondaryContactEmail: string | undefined | null,
    public SecondaryContactName: string | undefined | null,
    public PrimaryContactPhone: string | undefined | null,
    public SecondaryContactNotificationPeriod: PointOfContactPeriod | undefined | null,
    public ShortName: string | undefined | null
  ) {}
}

export class AgencyDetailsUpdateObjectResponse extends AgencyDetailsResponse {}

export class AgencySettings {
  constructor(
    public canDownloadClient: boolean,
    public canSelectiveUpload: boolean,
    public isLoginPinRequired: boolean,
    public useDownloadReason: boolean,
    public downloadReasonMinLength: number | null,
    public useMilitaryTime: boolean
  ) {}
}

export class AgencySettingsUpdateRequest {
  constructor(
    public CanDownloadClient: boolean,
    public CanSelectiveUpload: boolean,
    public DownloadReasonMinLength: number | null,
    public IsLoginPinRequired: boolean,
    public UseDownloadReason: boolean,
    public UseMilitaryTime: boolean
  ) {}
}

export class AgencySettingsResponse {
  constructor(
    public CanDownloadClient: boolean,
    public CanSelectiveUpload: boolean,
    public DownloadReasonMinLength: number,
    public IsLoginPinRequired: boolean,
    public UseDownloadReason: boolean,
    public UseMilitaryTime: boolean
  ) {}
}

export class SelfResponse {
  constructor(public Customer: AgencySettingsResponse) {}
}
